import AppConstants from '../../config/app.constants';

const permissions = {
	'tnt_billing': {
		title_key: 'common.side_menu.tnt_billing',
		icon: 'glyphicon glyphicon-calendar',
		state: 'tntBilling',
		menu: true,
		permission: {
			view: false,
			default_redirect: false
		},
		child: {
			'tnt_billing_billable_events': {
				title_key: 'billableEvents.menu.title',
				title: 'Billable Events',
				redirectState: 'billable_events',
				permission: {
					view: false,
					create: false,
					edit: false,
					delete: false,
					default_redirect: false
				}
			},
			'tnt_billing_billing_category': {
				title_key: 'billingCategory.menu.title',
				title: 'Billing Category',
				redirectState: 'billing_category',
				permission: {
					view: false,
					create: false,
					edit: false,
					// delete: false
					default_redirect: false
				}
			},
			'tnt_billing_contract': {
				title_key: 'contract.contract',
				title: 'Contract',
				redirectState: 'contract',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false,
					default_redirect: false
				}
			},
			'tnt_billing_customer': {
				title_key: 'location.customer',
				title: 'Customer',
				redirectState: 'customer',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false,
					default_redirect: false
				}
			},
			'tnt_billing_location_distance': {
				title_key: 'locationDistance.menu.title',
				title: 'Location Distance',
				redirectState: 'location_distance',
				permission: {
					edit: false,
					view: false,
					create: false,
					default_redirect: false
				}
			},
			'tnt_billing_fuel_surcharges': {
				title_key: 'common.side_menu.fuel_surcharges',
				title: 'Fuel Surcharges',
				// icon: 'glyphicon glyphicon-usd',
				// state: 'fuelSurcharges',
				state: 'tntBilling',
				redirectState: 'fuel_surcharges',
				menu: true,
				permission: {
					edit: false,
					view: false,
					create: false,
					default_redirect: false
				},
				expand: false,
				child: {
					'price_point': {
						title_key: 'price_point',
						title: 'Price Point',
						permission: {
							edit: false,
							view: false,
							create: false
						}
					},
				}
			},
			'tnt_billing_contract_type': {
				title_key: 'contractType.menu.title',
				title: 'Contract Type',
				redirectState: 'contract_type',
				permission: {
					edit: false,
					view: false,
					create: false,
					default_redirect: false
				}
			},
		}
	},
	'tnt_control': {
		title_key: 'common.side_menu.tnt_control',
		icon: 'glyphicon glyphicon-asterisk',
		state: 'tntControl',
		menu: true,
		permission: {
			view: false
		},
		child: {
			// 'tnt_control_configuration': {
			// 	title_key: 'configuration.menu.title',
			// 	title: 'Configuaration',
			// 	permission: {
			// 		view: false,
			// 		create: false,
			// 		edit: false,
			// 		delete: false
			// 	}
			// },
			'tnt_control_branch_setup': {
				title_key: 'setup.menu.title',
				title: 'Setup',
				permission: {
					view: false,
					create: false,
					edit: false,
					changeVaultDate: false
					// delete: false,
				}
			},
			'tnt_control_shiptype': {
				title_key: 'addBagModal.shiptype',
				title: 'Shiptype',
				permission: {
					view: false,
					create: false,
					edit: false,

				}
			},
			'tnt_control_denomination': {
				title_key: 'denomination.menu.title',
				title: 'Denomination',
				permission: {
					view: false,
					create: false,
					edit: false,
					// delete: false,
				}
			},
			'tnt_control_currency': {
				title_key: 'currency.menu.title',
				title: 'Currency',
				permission: {
					view: true,
					create: true,
					edit: true,
					// delete: false,
				}
			},
			'tnt_control_message': {
				title_key: 'message.types.M',
				title: 'Message',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'tnt_control_mobile_app': {
				title_key: 'mobileApp.menu.title',
				title: 'Mobile App',
				permission: {
					view: false,
					create: false,
				}
			},
			'tnt_control_user_permission_report': {
				title_key: 'userPermissionReport.menu.title',
				title: 'User Permission Report',
				permission: {
					view: false
				}
			},
			'tnt_control_atm_load_profile': {
				title_key: 'atmLoadProfile.menu.title',
				title: 'ATM Load Profile',
				permission: {
					edit: false,
					view: false,
					create: false
				}
			},
			'tnt_control_cost_center': {
				title_key: 'costCenter.menu.title',
				title: 'Cost Centers',
				permission:{
					edit: false,
					view: false,
					create: false
				}
			},
			'tnt_control_environment_config': {
				title_key: 'environment_config.menu.title',
				title: 'Environment Config',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'tnt_control_location_zone': {
				title_key: 'locationZone.menu.title',
				title: 'Location Zone',
				permission: {
					view: false,
					// create: false,
					edit: false,
					delete: false
				}
			},
			'tnt_control_notification_management': {
				title_key: 'notificationManagement.menu.title',
				title: 'Notification Management',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'tnt_control_service_assignment_rules':{
				title_key: 'serviceAssignmentRules.menu.title',
				title: 'Service Assignment Rules',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
		}
	},
	'branch_mgmt': {
		title_key: 'common.side_menu.branch_mgmt',
		icon: 'glyphicon glyphicon-map-marker',
		state: 'branchManagement',
		menu: true,
		permission: {
			view: false,
			default_redirect: false
		},
		child: {
			'branch_mgmt_routes': {
				title_key: 'route.all_routes',
				title: 'Routes',
				permission: {
					all: false
				}
			},
			'branch_mgmt_locations': {
				title_key: 'location.menu.title',
				title: 'Locations',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.locations'
			},
			'branch_mgmt_items': {
				title_key: 'branch_mgmt.items.title',
				title: 'Items',
				permission: {
					all: false,
					edit:false,
					default_redirect: false
				},
				state: 'branchManagement.items'
			},
			'branch_mgmt_tankers': {
				title_key: 'branch_mgmt.tankers.title',
				title: 'Tankers',
				permission: {
					all: false
				}
			},
			'branch_mgmt_bagouts': {
				title_key: 'branch_mgmt.bagout.title',
				title: 'Bagouts',
				permission: {
					all: false
				}
			},
			'branch_mgmt_orders': {
				title_key: 'branch_mgmt.orders.title',
				permission: {
					all: false,
					export_print: false,
					default_redirect: false
				},
				state: 'branchManagement.orders'
			},
			'branch_mgmt_item_holds': {
				title_key: 'branch_mgmt.item_holds.title',
				title: 'Item Holds',
				permission: {
					all: false
				}
			},
			'branch_mgmt_location_holds': {
				title_key: 'branch_mgmt.locationhold.title',
				title: 'Location Holds',
				permission: {
					all: false
				}
			},
			'branch_mgmt_bypass_code': {
				title_key: 'branch_mgmt.bypass_code.title',
				title: '4P Bypass Code',
				permission: {
					all: false
				}
			}, 'branch_mgmt_daily_balance_sheet': {
				title_key: 'branch_mgmt.daily_balance_sheet.title',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.dailyBalanceSheet'
			},
			'branch_mgmt_monthly_report': {
				title_key: 'branch_mgmt.monthly_report.title',
				title: 'Monthly Report',
				permission: {
					all: false
				}
			},
			'branch_mgmt_deleted_shipments': {
				title_key: 'branch_mgmt.deleted_shipments.title',
				title: 'Deleted Shipments',
				permission: {
					all: false
				}
			},
			'branch_mgmt_cancelled_shipments': {
				title_key: 'branch_mgmt.cancelled_shipments.title',
				title: 'Cancelled Shipments',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.cancelledShipments'
			},
			'branch_mgmt_branch_performance': {
				title_key: 'branch_mgmt.branch_performance.title',
				title: 'Branch Performance',
				permission: {
					all: false
				}
			},
			'branch_mgmt_final_residual_count_commit': {
				title_key: 'branch_mgmt.final_residual_count_commit.title',
				title: 'Final Residual Count Commit',
				permission: {
					all: false
				}
			},
			'branch_mgmt_cash_transactions': {
				title_key: 'branch_mgmt.cash_transactions.title',
				title: 'Cash Transactions',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.cashDeliveries'
			},
			'branch_mgmt_tnt_bypass_code': {
				title_key: 'branch_mgmt.tnt_bypass_code.title',
				title: 'TNT Bypass Code',
				permission: {
					all: false,
					overrideClose: false
				}
			},
			'branch_mgmt_physical_cash_count': {
				title_key: 'branch_mgmt.physical_cash_count.title',
				title: 'Physical Cash Count',
				permission: {
					all: false,
					edit: false
				}
			},
			'branch_mgmt_lock_open_errors': {
				title_key: 'branch_mgmt.lock_open_errors.title',
				title: 'Lock Open Errors',
				permission: {
					all: false
				}
			},
			'branch_mgmt_billing_approval': {
				title_key: 'branch_mgmt.billing_approval.title',
				title: 'Billing Approval',
				permission: {
					all:false,
					default_redirect: false
				},
				state: 'branchManagement.billingApproval',
				menu: true,
				expand:false,
				child: {
					'branch_mgmt_billing_approval_create_billing_record': {
						title_key: 'branch_mgmt.billing_approval.create_billing_record.title',
						title: 'Create Billing Record',
						permission: {
							allow: false
						}
					},
					'branch_mgmt_billing_approval_approve_billing_record': {
						title_key: 'branch_mgmt.billing_approval.approve_billing_record.title',
						title: 'Approve Billing Record',
						permission: {
							allow: false
						}
					},
					'branch_mgmt_billing_approval_edit_billing_record': {
						title_key: 'branch_mgmt.billing_approval.edit_billing_record.title',
						title: 'Edit Billing Record',
						permission: {
							allow: false
						}
					},
					'branch_mgmt_billing_approval_delete_billing_record': {
						title_key: 'branch_mgmt.billing_approval.delete_billing_record.title',
						title: 'Delete Billing Record',
						permission: {
							allow: false
						}
					},
				}
			},
			'branch_mgmt_count_variances': {
				title_key: 'branch_mgmt.count_variances.title',
				title: 'Count Variances',
				permission: {
					all: false
				}
			},
			'branch_mgmt_restore_route_assignments': {
				title_key: 'branch_mgmt.restore_route_assignments.title',
				title: 'Restore Route Assignments',
				permission: {
					all: false
				}
			},
			'branch_mgmt_stop_performance': {
				title_key: 'branch_mgmt.stop_performance.title',
				title: 'Stop Performance',
				permission: {
					all: false
				}
			},
			'branch_mgmt_customer_pickup_reports': {
				title_key: 'branch_mgmt.customer_pickup_reports.title',
				title: 'Customer Pickup Reports',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.customerPickupReports'
			},
			'branch_mgmt_contact_request': {
				title_key: 'branch_mgmt.contact_request.title',
				title: 'Contact Request',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.contactRequest'
			},
			'branch_mgmt_import_file_view': {
				title_key: 'branch_mgmt.import_file_view.title',
				title: 'ImportFile View',
				permission: {
					all: false
				}
			},
			'branch_mgmt_stop_scheduling': {
				title_key: 'branch_mgmt.stop_scheduling.title',
				title: 'Stop Scheduling',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.stopScheduling'
			},
			'branch_mgmt_average_daily_balance': {
				title_key: 'branch_mgmt.average_daily_balance.title',
				title: 'Average Daily Vault Balance',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.averageDailyBalance'
			},
			'branch_mgmt_bin_manifest': {
				title_key: 'branch_mgmt.bin_manifest.title',
				title: 'Bin Manifest',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.binManifest'
			},
			'branch_mgmt_deposit_reports': {
				title_key: 'branch_mgmt.deposit_reports.title',
				title: 'Deposit Reports',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.depositReports'
			},
			'branch_mgmt_mileage_report': {
				title_key: 'Mileage Report',
				title: 'Mileage Report',
				permission: {
					all: false
				}
			}
		}
	},
	'vault_operations': {
		title_key: 'common.side_menu.vault_operations',
		icon: '	glyphicon glyphicon-hdd',
		state: 'vaultOperations',
		menu: true,
		permission: {
			all: false
		}
	},
	'service_tickets': {
		title_key: 'common.side_menu.service_tickets',
		icon: 'glyphicon glyphicon glyphicon-tag',
		state: 'serviceTickets',
		menu: true,
		permission: {
			all: false,
			create: false,
			edit: false,
			assign: false,
			updateExternal: false,
			default_redirect: false
		}
	},
	'reporting': {
		title_key: 'common.side_menu.reporting',
		icon: 'glyphicon glyphicon-list-alt',
		state: 'reporting',
		menu: true,
		permission: {
			view: false
		},
		child: {
			'reporting_liability': {
				title_key: 'liability.menu.title',
				title: 'Liability',
				permission: {
					view: false
				}
			},
			'reporting_route_performance': {
				title_key: 'route_performance.menu.title',
				title: 'Route Performance',
				permission: {
					view: false
				}
			},
			'reporting_on_hold': {
				title_key: 'on_hold.menu.title',
				title: 'On Hold',
				permission:{
					view:false
				}
			}
		}
	},
	'route_control': {
		title_key: 'common.side_menu.route_control',
		icon: 'glyphicon glyphicon-map-marker',
		state: 'routeControl',
		menu: true,
		permission: {
			stopTransfer: false,
			adHocCheckin: false,
			all: false
		}
	},
	'check_out': {
		title_key: 'common.side_menu.check_out',
		icon: 'glyphicon glyphicon-backward',
		state: 'checkout',
		menu: true,
		permission: {
			all: false
		}
	},
	'check_in': {
		title_key: 'common.side_menu.check_in',
		icon: 'glyphicon glyphicon-forward',
		state: 'checkin',
		menu: true,
		permission: {
			all: false
		}
	},
	'route_throw': {
		title_key: 'common.side_menu.route_throw',
		icon: 'glyphicon glyphicon-backward',
		state: 'routeThrow',
		menu: true,
		permission: {
			all: false
		}
	},
	// 'downsort': {
	// 	title_key: 'common.side_menu.downsort',
	// 	icon: 'glyphicon glyphicon-arrow-down',
	// 	menu: true,
	// 	permission: {
	// 		all: false
	// 	}
	// },
	'bag_out': {
		title_key: 'common.side_menu.bag_out',
		icon: 'glyphicon glyphicon-briefcase',
		state: 'bagout',
		menu: true,
		permission: {
			all: false
		}
	},
	'bulk_transfer': {
		title_key: 'common.side_menu.bulk_transfer',
		icon: 'glyphicon glyphicon-transfer',
		state: 'bulkTransfer',
		menu: true,
		permission: {
			all: false
		},
		expand: false,
		child: {
			'bulk_transfer_new': {
				title_key: 'bulk_transfer.tab.new',
				title: 'New',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'bulk_transfer_active': {
				title_key: 'bulk_transfer.tab.active',
				title: 'Active',
				permission: {
					view: false,
					edit: false
				}
			},
			'bulk_transfer_closed': {
				title_key: 'bulk_transfer.tab.closed',
				title: 'Closed',
				permission: {
					view: false
				}
			}
		}
	},
	'route_progress': {
		title_key: 'common.side_menu.route_progress',
		icon: 'glyphicon glyphicon-road',
		state: 'routeProgress',
		menu: true,
		permission: {
			all: false
		}
	},
	'route_stats': {
		title_key: 'common.side_menu.route_stats',
		icon: 'glyphicon glyphicon-map-marker',
		state: 'routeStats',
		menu: true,
		permission: {
			all: false
		}
	},
	'setting': {
		title_key: 'common.side_menu.settings',
		icon: 'glyphicon glyphicon-cog',
		state: 'settings',
		menu: true,
		permission: {
			all: false,
			default_redirect: false
		},
		expand: false,
		child: {
			'setting-vault': {
				title_key: 'setup.vault',
				title: 'Vault',
				permission: {
					edit: false,
					delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-customer': {
			// 	title_key: 'location.customer',
			// 	title: 'Customer',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			// 'setting-contract': {
			// 	title_key: 'contract.contract',
			// 	title: 'Contract',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			'setting-items-type': {
				title_key: 'itemType.type',
				title: 'Item Type',
				permission: {
					edit: false,
					//delete: false,
					view: false,
					create: false
				}
			},
			'setting-items': {
				title_key: 'item.items',
				title: 'Item',
				permission: {
					edit: false,
					delete: false,
					view: false,
					create: false
				}
			},
			'setting-routes': {
				title_key: 'route.all_routes',
				title: 'Routes',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-carrier': {
				title_key: 'routeControl.carrier',
				title: 'Carrier',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-truck': {
				title_key: 'branch_mgmt.location_truck',
				title: 'Truck',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-batch': {
				title_key: 'addBagModal.batch',
				title: 'Batch',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-location': {
				title_key: 'bagout.location',
				title: 'Location',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false,
					importLocations: false,
					clone: false,
					editCustomer: false,
					deleteSaveLater: false,
					default_redirect: false
				},
				state: 'location.all'
			},
			'setting-branch': {
				title_key: 'checkout.branch',
				title: 'Branch',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-shiptype': {
			// 	title_key: 'addBagModal.shiptype',
			// 	title: 'Shiptype',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false

			// 	}
			// },
			'setting-users': {
				title_key: 'log.users',
				title: 'Users',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-message': {
			// 	title_key: 'message.types.M',
			// 	title: 'Message',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			'setting-holiday': {
				title_key: 'location.hol',
				title: 'Holiday',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-setup': {
			// 	title_key: 'setup.menu.title',
			// 	title: 'Setup',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			// 'setting-denomination': {
			// 	title_key: 'denomination.menu.title',
			// 	title: 'Denomination',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			'setting-branch-funding-source': {
				title_key: 'branchFundingSource.menu.title',
				title: 'Branch Funding Source',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-branch-funding-source-holiday': {
				title_key: 'branchFundingSourceHoliday.menu.title',
				title: 'Branch Funding Source Holiday',
				permission: {
					edit: false,
					delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-mobile-app': {
			// 	title_key: 'mobileApp.menu.title',
			// 	title: 'Mobile App',
			// 	permission: {
			// 		create: false,
			// 		view: false
			// 	}
			// },
			'setting-log': {
				title_key: 'log.menu.title',
				title: 'Log',
				permission: {
					view: false
				}
			},
			// 'setting-accounts': {
			// 	title_key: 'account.menu.title',
			// 	title: 'Account',
			// 	// permission: {
			// 		// view: false
			// 	// }
			// },
			'setting-reset-atm-code': {
				title_key: 'resetAtmCode.menu.title',
				title: 'Reset ATM Code',
				permission: {
					view: false
				}
			},
			// 'setting-soft-deleted-shipments': {
			// 	title_key: 'softDeletedShipments.menu.title',
			// 	title: 'Soft Deleted Shipments',
			// 	permission: {
			// 		view: false
			// 	}
			// }, 
			'setting-service-checklist': {
				title_key: 'serviceSettings.checklist.title',
				title: 'Service Checklist',
				permission: {
					view: false,
					create: false,
					edit: false,
					delete: false
				}
			},
			'setting-service-settings': {
				title_key: 'serviceSettings.menu.title',
				title: 'Service Settings',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'setting-delivery-region-routing': {
				title_key: 'deliveryRegionRouting.menu.title',
				title: 'Service Zones',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'setting-service-ticket-parts': {
				title_key: 'serviceTicketParts.menu.title',
				title: 'Service Ticket Parts',
				permission: {
					view: false,
					create: false,
					edit: false,
					delete: false
				}
			},
			"setting-preventative-maintenance": {
				title_key: 'Preventative Maintenance',
				title: 'Preventative Maintenance',
				permission: {
					view: false,
					create: false,
					edit: false,
					delete: false
				}
			},
		}
	},
	'route_sheet': {

		title_key: 'common.side_menu.route_sheet',
		icon: 'glyphicon glyphicon-map-marker',
		state: 'routeSheet',
		menu: true,
		permission: {
			all: false
		}
	},
	'shipment_batch': {

		title_key: 'common.side_menu.shipment_batch',
		icon: 'glyphicon glyphicon-list',
		state: 'shipmentBatch',
		menu: true,
		permission: {
			all: false
		}
	},
	'coin_pull_report': {

		title_key: 'common.side_menu.coin_pull_report',
		icon: 'glyphicon glyphicon-list',
		state: 'coin-pull-report',
		menu: true,
		permission: {
			all: false
		}
	},
	'vault_close': {

		title_key: 'common.side_menu.vault_close',
		icon: 'glyphicon glyphicon-lock',
		state: 'vaultClose',
		menu: true,
		permission: {
			all: false
		}
	},
	'order_packing': {
		title_key: 'common.side_menu.order_packing',
		icon: 'glyphicon glyphicon-compressed',
		state: 'orderPacking',
		menu: true,
		permission: {
			all: false,
			editRoute: false
		},
		child: {
			'currency_pick_report': {
				title_key: 'common.side_menu.currency_pick_report',
				icon: 'glyphicon glyphicon-list-alt',
				menu: true,
				permission: {
					view: false
				}
			}
		}
	},
	'cash_activity': {
		title_key: 'common.side_menu.cash_activity',
		icon: 'glyphicon glyphicon-list-alt',
		state: 'cashActivity',
		menu: true,
		permission: {
			customer: false,
			funding_source: false,
			default_redirect: false
		}
	},
	'ach_management': {
		title_key: 'common.side_menu.ach_management',
		icon: 'glyphicon glyphicon-briefcase',
		state: 'achManagement',
		menu: true,
		permission: {
			all: false,
			default_redirect: false
		}
	},
	'bulk_cash_management': {
		title_key: 'common.side_menu.bulk_cash_management',
		icon: 'glyphicon glyphicon-align-justify',
		state: 'bulkCashManagement',
		menu: true,
		permission: {
			view: false,
			all: false,
			debit:false,
			report: false,
			export: false,
			default_redirect: false
		}
	},
	'atm_count': {
		title_key: 'branch_mgmt.cash_count',
		icon: 'glyphicon glyphicon-credit-card',
		state: 'atmCount',
		menu: true,
		permission: {
			editCommitted: false,
			all: false
		}
	},
	'master_cash_schedule': {
		title_key: 'common.side_menu.master_cash_schedule',
		icon: 'glyphicon glyphicon-dashboard',
		state: 'masterCashSchedule',
		menu: true,
		permission: {
			all: false,
			view: false,
			create: false,
			edit: false,
			delete: false,
			atRisk: false,
			default_redirect: false
		},
		expand: false,
		child: {
			'scheduled_shipment': {
				title_key: 'scheduled_shipment.title',
				title: 'Scheduled Shipment',
				permission: {
					edit: false,
					view: false,
					create: false
				}
			},
		}
	},
	'deposit_packing': {
		title_key: 'common.side_menu.deposit_packing',
		icon: 'glyphicon glyphicon-folder-close',
		state: 'depositPacking',
		menu: true,
		permission: {
			all: false
		}
	},
	'tnt_react_app': {
		title_key: "React App",
		icon: "glyphicon glyphicon-asterisk",
		state: "tntReactApp",
		menu: true,
		permission: {
			all: false,
			default_redirect: false
		},
	},
	'on_demand_call': {
		title_key: "On Demand Service",
		icon: "glyphicon glyphicon-map-marker",
		state: "onDemandCall",
		menu: true,
		permission: {
			all: false,
			default_redirect: false
		},
	},
	'coin_management': {
		title_key: "Coin Management",
		icon: "glyphicon glyphicon glyphicon-compressed",
		state: "coinManagement",
		menu: true,
		permission: {
			all: false,
		},
	},
	'pickup_request_management': {
		title_key: "Pickup Request",
		icon: "glyphicon glyphicon-inbox",
		state: "pickupRequestManagement",
		menu: true,
		permission: {
			view: false,
			edit:false,
			delete: false,
			default_redirect: false
		},
	},
	"atm_codes_management": {
		title_key: 'common.side_menu.atm_codes_mgmt',
		icon: 'glyphicon glyphicon-modal-window',
		state: 'atmCodesManagement',
		menu: true,
		permission: {
			all: false
		}
	},
	"system_configuration": {
		title_key: 'System Configuration',
		icon: 'glyphicon glyphicon-modal-window',
		state: 'systemConfiguration',
		menu: true,
		permission: {
			all: false
		}
	},
	"tnt_app_event_logs": {
		title_key: 'TNT App Event Logs',
		icon: 'glyphicon glyphicon-list-alt',
		state: 'appEventLogs',
		menu: true,
		permission: {
			all: false
		}
	},
	// 'vault_balance': {
	// 	title_key: 'common.side_menu.vault_balance',
	// 	icon: 'glyphicon glyphicon-piggy-bank',
	// 	state: 'vaultBalance',
	// 	menu: true,
	// 	permission: {
	// 		all: false
	// 	}
	// }
}

let AuthFactory = function ($http, $cookies) {
	let login = (userCredentials) => {
		return $http
			.post(AppConstants.api + `/user/authenticate`, userCredentials)
			.then((res) => {
				const data = res.data;
				if (data && data.message !== 'failed' && !data.validate2FA) {
					$cookies.putObject('user', data);

					localStorage.setItem('user', data.id);
					localStorage.setItem('loginTime', new Date().getTime());
					localStorage.setItem('email', data.email);
					localStorage.setItem('name', data.name);
					return res.data;
				}
				else {
					return res.data;
				}
			})
	};

	let isUserEmailExist = (userCredentials) => {
		return $http
			.post(AppConstants.api + `/user/verify-email`, userCredentials)
			.then((res) => {
				return res.data
			})
	};
	let resetUserPassword = (userCredentials) => {
		return $http
			.post(AppConstants.api + `/user/reset-password`, userCredentials)
			.then((res) => {
				return res.data
			})
	};

	let isAuthenticated = () => {
		return !!localStorage.getItem('email') || !!localStorage.getItem('user');
	}

	let logout = () => {
		return $http
			.post(AppConstants.api + `/user/logout`)
			.then((res) => {
				localStorage.removeItem('user')
				localStorage.removeItem('loginTime')
				localStorage.removeItem('email')
				localStorage.removeItem('name')
				localStorage.removeItem('sessionLength')
			})
	}

	let permissionMap = () => {
		return permissions;
	}
	let permission = () => {
		const permissionsCopy = angular.copy(permissions);

		// vault tab is commented out in setting tabs
		delete permissionsCopy.setting.child['setting-vault'];
		return permissionsCopy;
	}

	return {
		login,
		logout,
		permissionMap,
		isAuthenticated,
		permission,
		isUserEmailExist,
		resetUserPassword
	};
};

AuthFactory.$inject = ['$http', '$cookies']

export default AuthFactory;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.factory.js